enum SpaceTypo {
    CirculationH,
    Escalier,
    Ascenseur,
    Gaine,
    InterieurAppartement,
    Loggia, // Déprécié
    Balcon, // Déprécié (pour les projets en cours fusionné en SUexterieure)
    Terrasse, // Déprécié (pour les projets en cours fusionné en SUexterieure)
    Exterieure,
    Local,
    Parking,
    Commerce,
    VideSurHall,
    Aucun,
    SUexterieure
}

export default SpaceTypo;